












import {Component, Vue} from 'vue-property-decorator'

@Component
export default class ModalMotoristaEdit extends Vue {

  src = ''

  async openEvent(src?: string) {
    this.$emit('open')
    this.src = src || ''
  }

  closeEvent() {
    this.src = ''
    this.$emit('close')
  }

  close() {
    this.$modal.close('imageDisplay')
  }

}
